<h1 class="title" mat-dialog-title>{{ dialogTitle }}</h1>
@if (!readonly) {
  <div class="description" mat-dialog-content [innerHTML]="dialogDescription"></div>
}
<div class="actions" mat-dialog-actions>
  <mat-form-field class="code-area">
    <textarea rows="20" matInput spellcheck="false" [disabled]="readonly" [(ngModel)]="dialogCodeArea"
    (ngModelChange)="clearValidation()"></textarea>
  </mat-form-field>

  @if (validationError) {
    <div class="validation-error">
      {{validationError}}
    </div>
  }

  @if (!readonly) {
    <mat-form-field class="code-area">
      <div class="notes-label">Reason for edit...</div>
      <input class="notes-input" matInput type="text" [(ngModel)]="releaseNotes"/>
    </mat-form-field>
  }

  <div class="buttons">
    @if (!readonly) {
      <button mat-raised-button class="mat-accent" (click)="save()"
      id="jsonSaveButton">{{ dialogConfirmButtonText }}</button>
    }
    <button mat-raised-button class="mat-warn" (click)="cancel()"
    id="jsonCancelButton">{{ dialogCancelButtonText }}</button>
  </div>
</div>